import {BehaviorSubject} from "rxjs";
import {EntitlementData, EntitlementStatus} from "./entitlement-entity.model";

export class DealEvents {

    /**
     * Notifies the current entitlement.
     */
    public static readonly currentEntitlement$: BehaviorSubject<EntitlementData> = new BehaviorSubject(undefined);

    /**
     * Notifies a change in the current entitlement status.
     */
    public static readonly currentEntitlementStatus$: BehaviorSubject<EntitlementStatus> = new BehaviorSubject(EntitlementStatus.NONE);
}



// WEBPACK FOOTER //
// ./src/app/deal/deal-events.ts